<template>
  <div class="header">
    <h1>You are now subscriped, Read my friend</h1>
  </div>
</template>

<script>
export default {
  name: 'Subscribed',
  data() {
    return {};
  },
  props: {},
  mounted() {},
};
</script>

<style scoped>
.header {
  padding: 20px;
  z-index: 99;
  font-family: 'Poppins', sans-serif;
  /* position: absolute; */
  /* bottom: 0; */
  /* right: 130px; */
  font-size: 18px;
  font-weight: 700;
  /* color: #fff; */
}
</style>
